import moment from 'moment'
import { modalError } from './modalUtils'
import store from '../redux'
const _ = require('lodash')
const modulesFilesen = require.context('../locale/en', true, /\.js$/)
const modulesen = modulesFilesen.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
  const value = modulesFilesen(modulePath)
  modules[moduleName] = value
  return modules
}, {})
const modulesFileszh = require.context('../locale/zh', true, /\.js$/)
const moduleszh = modulesFileszh.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
  const value = modulesFileszh(modulePath)
  modules[moduleName] = value
  return modules
}, {})
export const languageObj = {
  zh_CN: moduleszh,
  en_US: modulesen
}
export const dateFormatYear = 'YYYY'
export const dateFormatYearMonth = 'YYYY-MM'
export const dateFormatYearMonthDay = 'YYYY-MM-DD'
export const dateFormatYearMonthDay2 = 'YYYYMMDD'
export const dateFormatMonthDayYear = 'MM/DD/YYYY'
export const dateFormatMonthDayYear2 = 'M/D/YYYY'
export const dateFormatYearMonthDayTime = 'YYYY-MM-DD HH:mm:ss'
export const formatMessage = (titles, storeState) => {
  let titleList = titles.split('.')
  let resObj = {}
  if (storeState) {
    resObj = _.cloneDeep(storeState)
  } else {
    const state = store.getState()
    const commonStore = state.commonStore
    resObj = _.cloneDeep(commonStore)
  }
  for (let index = 0; index < titleList.length; index++) {
    const element = titleList[index]
    if (resObj[element]) {
      resObj = resObj[element]
    } else {
      resObj = ''
    }
  }
  return resObj.toString()
}

export const initCurryingObj = (list = []) => {
  let obj = {}
  list.forEach(item => {
    obj[item.value] = item.label
    obj[item.label] = item.value
  })
  return obj
}
export const reSendPermission = ['Admin']
export const paginationInit = {
  pageSize: 10,
  currentPage: 1,
  total: 0
}
export const pageSizeOptions = [10, 20, 50, 100]
export const handleChange = (e, obj, cb) => {
  let dt
  let val = e && e.target ? e.target.value : e
  if (Object.prototype.toString.call(obj.state) === '[object Object]') {
    dt = {
      ...obj.state,
      [obj.key]: val.trim()
    }
  } else {
    dt = val.trim()
  }
  obj.setState(dt)
  cb && cb()
}
export const handleChangeArr = (e, obj, cb) => {
  let val = e && e.target ? e.target.value : e
  let dt = [...obj.state]
  dt[obj.idx][obj.key] = val
  obj.setState(dt)
  cb && cb()
}
export const handleChangeSelAll = (e, mode) => {
  if (mode === 'multiple') {
    let sel = []
    if (e && e.length > 0) {
      if (e[e.length - 1] === 'All') {
        sel = ['All']
      } else {
        sel = e.filter(itemFil => itemFil !== 'All')
      }
    }
    return sel
  } else {
    return e
  }
}
export const handleCleanAll = (params, key) => {
  let res = []
  if (params[key].indexOf('All') > 0) {
    res = []
  } else {
    res = params[key].filter(item => item !== 'All')
  }
  return res
}
export const getQuartersPreOrNext = startDate => {
  let quarterList = getQuarters()
  // let format = 'YYYY-MM-DD HH:mm:ss'
  let de = moment(startDate || undefined)
  let quarter = moment(startDate || undefined)
    .add(0, 'Q')
    .quarter()
  let endVal, startVal
  switch (quarter) {
    case 1:
      startVal = `${de.year() - 1}-12-20 00:00:00`
      endVal = `${de.year()}-03-20 00:00:00`
      break
    case 2:
      startVal = `${de.year()}-03-20 00:00:00`
      endVal = `${de.year()}-06-20 00:00:00`
      break
    case 3:
      startVal = `${de.year()}-06-20 00:00:00`
      endVal = `${de.year()}-09-20 00:00:00`
      break
    case 4:
      startVal = `${de.year()}-09-20 00:00:00`
      endVal = `${de.year()}-12-20 00:00:00`
      break
    default:
      break
  }
  if (de.isAfter(moment(startVal)) && de.isBefore(moment(endVal))) {
    return quarterList[0].value
  } else {
    return quarterList[1].value
  }
}

export const fiscalYearsList = ['Q1', 'Q2', 'Q3', 'Q4']
export const sortFiscalYears = list => {
  let unique = _.sortBy(list, x =>
    _.findIndex(fiscalYearsList, y => {
      return x.value.substring(0, 2) === y
    })
  )
  unique = _.sortBy(unique, item => {
    return -item.value.substring(2, 6)
  })
  return unique
}

export const seasonList = ['SP', 'SU', 'FA', 'HO']
export const sortSeasons = list => {
  let unique = _.sortBy(list, x =>
    _.findIndex(seasonList, y => {
      return x.value.substring(0, 2) === y
    })
  )
  unique = _.sortBy(unique, item => {
    return item.value.substring(2)
  })
  return unique
}
export const getQuarters = (startDate, end = 4, start = 0) => {
  const dateFormat = 'YYYY'
  let seasonDatas = {
    1: 'SP',
    2: 'SU',
    3: 'FA',
    4: 'HO'
  }
  let resSeasons = []
  for (let index = start; index <= end; index++) {
    let item = moment(startDate || undefined).add(index, 'Q')
    let resItem = `${seasonDatas[item.quarter()]}${item.format(dateFormat)}`
    resSeasons.push({
      value: resItem,
      label: resItem
    })
  }
  return resSeasons
}
export const getFiscalYearQuarter = () => {
  let list = []
  let M = moment().month() + 1
  let Y = moment().year() + 1
  if (M >= 6 && M <= 8) {
    list = ['FY' + (Y + '').substring(2, 4) + 'Q1', 'FY' + (Y - 1 + '').substring(2, 4) + 'Q4']
  }
  if (M >= 9 && M <= 11) {
    list = ['FY' + (Y + '').substring(2, 4) + 'Q2', 'FY' + (Y + '').substring(2, 4) + 'Q1']
  }
  if (M === 12 || M <= 2) {
    let Y0 = Y
    if (M === 12) {
    } else {
      Y0 = Y - 1
    }
    list = ['FY' + (Y0 + '').substring(2, 4) + 'Q3', 'FY' + (Y0 + '').substring(2, 4) + 'Q2']
  }
  if (M >= 3 && M <= 5) {
    list = ['FY' + (Y - 1 + '').substring(2, 4) + 'Q4', 'FY' + (Y - 1 + '').substring(2, 4) + 'Q3']
  }
  return initValueAndLabel(list)
}
export const getCRDMonths = (startDate, end = 5, start = 0) => {
  const dateFormat = 'YYYYMM'
  let resSeasons = []
  for (let index = start; index <= end; index++) {
    let item = moment(startDate || undefined)
      .add(index, 'months')
      .format(dateFormat)
    resSeasons.push({
      value: item,
      label: item
    })
  }

  return resSeasons
}
/**
 *
 * @param {*} list {key: key, value: value} Array
 * @param {*} type 1: month, 2: quarter
 * @returns
 */
export const getNowMonth = (list, type = 1) => {
  if (!list || list.length === 0) return
  let now = getCRDMonths()
  if (type === 2) {
    now = getQuarters()
  }
  if (_.find(list, ['value', now[0].value])) {
    return now[0].value
  } else {
    return list[0].value
  }
}
export const downLoadFileBlob = (res, fileName, type = 'application/vnd.ms-excel;charset=utf-8') => {
  const reader = new FileReader()
  reader.readAsText(res.data)
  reader.onload = () => {
    try {
      const response = JSON.parse(reader.result)
      if (response.errorcode === '5101') {
        modalError({
          content: formatMessage('languageObj.commonLocale.downloadError')
        })
      } else {
        modalError({
          content: formatMessage('languageObj.httpLocale.requestError')
        })
      }
    } catch (err) {
      // 下载正常处理
      var downFileName = fileName
      try {
        downFileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
        downFileName = unescape(downFileName)
      } catch {
        console.log('file name is empty')
      }
      let fileArr = downFileName.split('.')
      let extensionName = fileArr[fileArr.length - 1]
      let blob
      if (extensionName === 'zip') {
        blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
      } else {
        blob = new Blob([res.data], { type: type })
      }
      var url = window.URL.createObjectURL(blob)
      var aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = url
      aLink.setAttribute('download', downFileName)
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      window.URL.revokeObjectURL(url)
    }
  }
}
/**
 * 下载Json工具
 * @param data
 * @param fileName
 */
export const saveAsJson = (str, fileName) => {
  //指定类型文件类型application/json;charset=utf-8
  const blob = new Blob([str], { type: 'application/json;charset=utf-8' })
  const href = URL.createObjectURL(blob)
  const alink = document.createElement('a')
  alink.style.display = 'none'
  alink.download = fileName // 下载后文件名
  alink.href = href
  document.body.appendChild(alink)
  alink.click()
  document.body.removeChild(alink) // 下载完成移除元素
  URL.revokeObjectURL(href) // 释放掉blob对象
}

/**
 * 下载本地、url文件
 * @param href
 */
export const downloadTemplate = (href, fileName) => {
  const alink = document.createElement('a')
  alink.style.display = 'none'
  if (fileName) {
    alink.download = fileName // 下载后文件名
  }
  alink.href = href
  document.body.appendChild(alink)
  alink.setAttribute('target', '_blank')
  alink.click()
  document.body.removeChild(alink) // 下载完成移除元素
  URL.revokeObjectURL(href) // 释放掉blob对象
}

export const uniqueFun = list => {
  let uniqueArr = _.uniqWith(list, (a, b) => a.value === b.value)
  return uniqueArr
}
export const uniqueFun2 = list => {
  let uniqueArr = _.uniqWith(list, (a, b) => a === b)
  return uniqueArr
}

export const numFormat = n => {
  let re = /\d{1,3}(?=(\d{3})+$)/g
  let n1 = n
  if (n) {
    n = n.toString()
    n1 = n.replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) {
      return s1.replace(re, '$&,') + s2
    })
  }
  return n1
}

export const bigIntegerFormatNike = (num, type = 1) => {
  //type 1: amount 2：quantity
  if (num) {
    if (type === 1) {
      if (num >= 1000000000 || num <= -1000000000) {
        return '$' + numFormat((num / 1000000000).toFixed(1)) + 'B'
      } else if ((num >= 1000000 && num < 1000000000) || (num > -1000000000 && num <= -1000000)) {
        return '$' + numFormat((num / 1000000).toFixed(1)) + 'M'
      } else if ((num < 1000000 && num >= 1000) || (num <= -1000 && num > -1000000)) {
        return '$' + numFormat((num / 1000).toFixed(1)) + 'K'
      } else {
        return '$' + num.toFixed(1)
      }
    } else {
      if ((num >= 1000 && num < 1000000) || (num > -1000000 && num <= -1000)) {
        return numFormat((num / 1000).toFixed(1)) + 'Ku'
      } else if (num >= 1000000 || num <= -1000000) {
        return numFormat((num / 1000000).toFixed(1)) + 'Mu'
      } else {
        return Math.floor(num) + 'u'
      }
    }
  } else if (num === 0 || num === '0') {
    return 0
  } else {
    return '-'
  }
}
export const bigFormatNike = (num, type = 1) => {
  //type 1: amount 2：quantity
  if (num) {
    if (type === 1) {
      return '$' + numFormat(num)
    } else {
      return numFormat(num)
    }
  } else if (num === 0 || num === '0') {
    return 0
  } else {
    return '-'
  }
}
export const selectMonth = () => {
  const list = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const month = moment().month()
  return list[month]
}
export const isObject = value => {
  return Object.prototype.toString.call(value) === '[object Object]'
}
/**
 *
 * @param Array
 * @returns Array {value: T, label: T}
 */
export const initValueAndLabel = (list, keyObj = { value: 'value', label: 'label' }) => {
  return list.map(item => {
    // 当 item 为对象时，优先使用其已有 value/label，否则自动生成
    if (isObject(item)) {
      return {
        ...item,
        value: item[keyObj.value],
        label: item[keyObj.label]
      }
    } else {
      return {
        value: item,
        label: item
      }
    }
  })
}
export const uniqueResPush = objMap => {
  let res = []
  if (!objMap) {
    return res
  }
  _.forOwn(objMap, (item, key) => {
    res.push({
      value: key,
      label: key
    })
  })
  return res.filter(item => item.value)
}
export const uniqueResListPush = objMap => {
  let res = []
  if (!objMap) {
    return res
  }
  objMap.filter(Boolean).forEach(item => {
    res.push({
      value: item,
      label: item
    })
  })
  return res
}
export const defaultRoleList = ['msc supervisor', 'admin']

export const formatStartTime = (date, type = 1, format = dateFormatYearMonthDay) => {
  const start = date && date[0] ? date[0].format(format) : null
  const startTime = start ? start + ' 00:00:00' : start
  return type === 1 ? startTime : start
}

export const formatEndTime = (date, type = 1, format = dateFormatYearMonthDay) => {
  const end = date && date[1] ? date[1].format(format) : null
  const endTime = end ? end + ' 23:59:59' : end
  return type === 1 ? endTime : end
}
export const initDateFormat = (de, format = dateFormatYearMonthDay) => {
  return de ? moment(de).format(format) : de
}
